import { render, staticRenderFns } from "./AreaOfUseSection.vue?vue&type=template&id=559d8a81&"
import script from "./AreaOfUseSection.vue?vue&type=script&lang=js&"
export * from "./AreaOfUseSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports